import React, { createContext, useContext } from "react";
import { db } from "./firebaseConfig"; // Your Firebase configuration file

const FirestoreContext = createContext();

export const FirestoreContextProvider = ({ children }) => {
  return <FirestoreContext.Provider value={db}>{children}</FirestoreContext.Provider>;
};

export const useFirestore = () => {
  const context = useContext(FirestoreContext);
  if (context === undefined) {
    throw new Error("useFirestore must be used within a FirestoreContextProvider");
  }
  return context;
};
